import React from "react"
import { useCMSReady } from "../../../../domain/CMS/useCMSReady"
import Typography, { typographyTypes } from "../Typography"

interface PreferredLocationProps {
  locationData: {
    careType: string
    officeLocation: string
    practice: string
    provider: string
  }
}

type LocationKeys = keyof PreferredLocationProps["locationData"]

export const PreferredLocation: React.FC<PreferredLocationProps> = ({
  locationData,
}) => {
  const { cms: cmsContent } = useCMSReady(["requestReferralModal"])
  const preferredLocationContent = cmsContent?.requestReferralModal
  const displayOrder: LocationKeys[] = [
    "provider",
    "practice",
    "careType",
    "officeLocation",
  ]

  const displayNames: Record<LocationKeys, string> = {
    provider: preferredLocationContent?.preferredLocationProviderLabel || "",
    practice: preferredLocationContent?.preferredLocationPracticeLabel || "",
    careType: preferredLocationContent?.preferredLocationCareTypeLabel || "",
    officeLocation:
      preferredLocationContent?.preferredLocationOfficeLabel || "",
  }

  return (
    <div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-0.5">
      {displayOrder.map((key) => (
        <React.Fragment key={key}>
          <Typography
            key={`key-${key}`}
            text={`${displayNames[key]}:`}
            styleOverrides="whitespace-nowrap"
            variant={typographyTypes.LABEL}
          />
          <Typography
            key={`value-${key}`}
            text={locationData[key]}
            variant={typographyTypes.NORMAL}
          />
        </React.Fragment>
      ))}
    </div>
  )
}
